export default "__VITE_ASSET__C2YU5n$1__"